import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { ADVANCEMENT_CLARO_PAY } from '../../../constants';

const Container = styled.div`
	${props => props.$isContainerTelcel &&
		css`
			padding: 0px 16px;
			&:not(:last-child) {
				margin: 0px 0px 24px 0px;
			}
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			padding: 0px 16px;			
			&:not(:last-child) {
				margin: 0px 0px 18px 0px;
			}
			&:first-child {
				margin-top: 18px;
			}
		`
	}
`;

const Card = styled.div`
	${props => props.$isContainerTelcel &&
		css`
			border-radius: 5px;
			background: #FFF;
			box-shadow: 0 0 30px 0 rgba(1, 32, 36, 0.15);
			display: grid;
			grid-template-columns: 1fr 138px;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			border-radius: 5px;
			background: #FFF;
			box-shadow: 0 0 30px 0 rgba(1, 32, 36, 0.15);
			display: grid;
			grid-template-columns: 1fr 138px;
		`
	}
`;

const DescriptionContainer = styled.div`
	${props => props.$isContainerTelcel &&
		css`
			text-align: center;
			padding: ${props.$condition ? "10px 16px" : "0px 10px"}
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			text-align: center;
			padding: ${props.$condition ? "10px 16px" : "0px 10px"}
		`
	}
`;

const MB_Image = styled.img`
	${props => props.$isContainerTelcel &&
		css`
			width: 32px;
			margin: 0px 0px 0px 0px;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			width: 32px;
			margin: 0px 0px 0px 0px;
		`
	}
`;

const MB_Text = styled.p`
	${props => props.$isContainerTelcel &&
		css`
			color: #222;
			font-family: AMX-Bold;
			font-size: 12px;
			line-height: 24px;
			margin: 0px;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			color: #50626c;
			font-family: AMX-Bold;
			font-size: 12px;
			line-height: 24px;
			margin: 0px;
		`
	}
`;

const Condition = styled.p`
	${props => props.$isContainerTelcel &&
		css`
			color: #222;
			font-family: AMX-Regular;
			font-size: 12px;
			line-height: 24px;
			margin: 0px;
			padding: 14px 16px 11px 16px;
			border-top: 1px solid #9AC1F9;
			width: 100%;
    		box-sizing: border-box;
			text-align: center;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			color: #50626c;
			font-family: AMX-Regular;
			font-size: 12px;
			line-height: 24px;
			margin: 0px;
			padding: 14px 16px 11px 16px;
			border-top: 1px solid #D0D0D0;
			width: 100%;
    		box-sizing: border-box;
			text-align: center;
		`
	}
`;

const ConditionValue = styled.span`
	${props => props.$isContainerTelcel &&
		css`
			font-family: AMX-Bold;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			font-family: AMX-Bold;
		`
	}
`;

const Image = styled.img`
	${props => props.$isContainerTelcel &&
		css`
			width: 100%;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			width: 100%;
		`
	}
`;

const AmountContainer = styled.div`
	${props => props.$isContainerTelcel &&
		css`
			border-left: 1px solid #9AC1F9;
			padding: 12px 12px 16px 12px;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			border-left: 1px solid #D0D0D0;
			padding: 12px 12px 16px 12px;
		`
	}
`;

const Label = styled.span`
	${props => props.$isContainerTelcel &&
		css`
			color: #222;
			font-family: AMX-Bold;
			font-size: 12px;
			line-height: 20px;
			margin: 0px;
			display: inline-block;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			color: #50626c;
			font-family: AMX-Bold;
			font-size: 12px;
			line-height: 20px;
			margin: 0px;
			display: inline-block;
		`
	}
`;

const Amount = styled.span`
	${props => props.$isContainerTelcel &&
		css`
			color: #008000;
			font-family: AMX-Bold;
			font-size: 20px;
			line-height: 28px;
			margin: 0px;
			display: block;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			color: #a6ce4e;
			font-family: AMX-Bold;
			font-size: 20px;
			line-height: 28px;
			margin: 0px;
			display: block;
		`
	}
`;

const Vigency = styled.span`
	${props => props.$isContainerTelcel &&
		css`
			color: #222;
			font-family: AMX-Regular;
			font-size: 12px;
			line-height: 16px;
			margin: 0px 0px 18px 0px;
			display: inline-block;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			color: #50626c;
			font-family: AMX-Regular;
			font-size: 12px;
			line-height: 16px;
			margin: 0px 0px 18px 0px;
			display: inline-block;
		`
	}
`;

const Button = styled.button`
	${props => props.$isContainerTelcel &&
		css`
			background: ${props.$isAdvancementClaroPay ? "#1470d1" : "#7B1FA2"};
			border-radius: 100px;
			padding: ${props.$isAdvancementClaroPay ? "11px 10px 9px 10px" : "8px 10px 8px 10px"};
			color: #fff;
			font-family: AMX-Bold;
			font-size: ${props.$isAdvancementClaroPay ? "12px" : "16px"};
			width: 100%;
			border: none;
		`
	}

	${props => !props.$isContainerTelcel &&
		css`
			background: ${props.$isAdvancementClaroPay ? "#1470d1" : "#000"};
			border-radius: 100px;
			padding: ${props.$isAdvancementClaroPay ? "11px 10px 9px 10px" : "8px 10px 8px 10px"};
			color: #fff;
			font-family: AMX-Bold;
			font-size: ${props.$isAdvancementClaroPay ? "12px" : "16px"};
			width: 100%;
			border: none;
		`
	}
`;


const InternetByTimeCard = ({ isContainerTelcel, plan={}, productId, executeOnClick, approvedToAdvancementClaroPay }) => {			
	const IMAGE_TELCEL = plan.promotions && plan.promotions.PromotionCOD ? plan.promotions.PromotionCOD : "";
	const IMAGE_CLAROP = plan.promotions && plan.promotions.PromotionCODCP ? plan.promotions.PromotionCODCP : "";
	const AMOUNT = "$" + Number(plan.cost);
	const VIGENCY_DAYS = plan.validityDays;
	const VIGENCY_HOURS = plan.validityHours;
	const CONDITION = plan.condition;
	const MEGAS = plan.megas;
	

	const getMB_Image = () => {
		return isContainerTelcel 
			? "/images/social_networks/globe_02.png"
			: "/images/social_networks/globe_02.png";
	}

	const getVigency = () => {
		let vigency = "";

		if (VIGENCY_DAYS) {
			vigency = VIGENCY_DAYS + (VIGENCY_DAYS == 1 ? " día" : " días");
		}

		if (VIGENCY_HOURS) {
			vigency = VIGENCY_HOURS + (VIGENCY_HOURS == 1 ? " hora" : " horas");
		}

		if ((IMAGE_TELCEL && isContainerTelcel) || (IMAGE_CLAROP && !isContainerTelcel)) {
			vigency += " de Internet Ilimitado";
		}

		return vigency;
	}

	return (
		<Container 
			$isContainerTelcel={isContainerTelcel} 
			onClick={() => {
				isContainerTelcel 
					? executeOnClick(plan.cost, productId, plan.mb, false) 
					: () => false
			}}>
			<Card $isContainerTelcel={isContainerTelcel}>
				<div>
					{
						(IMAGE_TELCEL && isContainerTelcel) || 
						(IMAGE_CLAROP && !isContainerTelcel)
							?
								<Image 
									$isContainerTelcel={isContainerTelcel} 
									src={isContainerTelcel ? IMAGE_TELCEL : IMAGE_CLAROP} 
								/>
							:
								<div style={{ 
									display: 'flex', 
									alignItems:'center', 
									justifyContent: 'center', 
									height: !CONDITION ? "100%" : "auto",
									flexDirection: 'column'
								}}>
									<DescriptionContainer 
										$isContainerTelcel={isContainerTelcel} 
										$condition={CONDITION}
									>
										<MB_Image 
											$isContainerTelcel={isContainerTelcel} 
											src={getMB_Image()} 
										/>
										{
											MEGAS &&
											<MB_Text $isContainerTelcel={isContainerTelcel}>
												{MEGAS}<br />
												para navegar en internet
											</MB_Text>
										}
									</DescriptionContainer>
									
									{
										CONDITION &&
										<Condition $isContainerTelcel={isContainerTelcel}>
											Política de uso justo:&nbsp;
											<ConditionValue 
												$isContainerTelcel={isContainerTelcel}
												dangerouslySetInnerHTML={{ __html: CONDITION }}
											/>
										</Condition>
									}
								</div>
					}
				</div>
				<AmountContainer $isContainerTelcel={isContainerTelcel}>
					<Label $isContainerTelcel={isContainerTelcel}>
						Costo:
					</Label>
					<Amount 
						$isContainerTelcel={isContainerTelcel} 
						dangerouslySetInnerHTML={{ __html: AMOUNT }}
					/>
					<Label $isContainerTelcel={isContainerTelcel} $isVigency={true}>
						Vigencia:&nbsp;
					</Label>
					<Vigency $isContainerTelcel={isContainerTelcel}>
						{getVigency()}
					</Vigency>
					{
						approvedToAdvancementClaroPay && parseInt(plan.cost) <= 100 &&
						<Button
							$isContainerTelcel={isContainerTelcel}
							$isAdvancementClaroPay={true}
							onClick={() => {
								executeOnClick(plan.cost, productId, plan.mb, true) 
							}}
							style={{ marginBottom: '12px' }}
						>
							Usar adelanto
						</Button>
					}
					<Button 
						$isContainerTelcel={isContainerTelcel}						
						onClick={() => {
							if (!isContainerTelcel) {
								executeOnClick(plan.cost, productId, plan.mb, false)
							}
						}}>
							Lo quiero
					</Button>
				</AmountContainer>
			</Card>			
		</Container>
	)
}

const mapStateToProps = (state) => {
    const { payments } = state;
    const isContainerTelcel = payments.isContainerTelcel;
    return {
       isContainerTelcel,
    }
}

export default connect (mapStateToProps)(InternetByTimeCard);